import React from 'react';

import {
    useModalStore,
    useAdobeTarget,
    useContainers,
} from 'bdvp-common/src/hooks/store';
import { useMediaConfigHome, useLang } from 'bdvp-common/src/hooks/config';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import Component from '../components/Homepage';

const { FILTER_MODAL_NAME } = modalConstants;

const Homepage = () => {

    const {
        adobeTarget: adobeTargetConfig = {},
        defaultContainerId = {
            en: 'Homepage V1',
            es: 'Homepage V1 - ES',
        },
    } = useMediaConfigHome();
    const {
        loading: isTargetOfferLoading,
        payload = {},
        enabled,
    } = useAdobeTarget(adobeTargetConfig, 'homepageContainer');
    const lang = useLang();
    const containerId = payload[lang] || defaultContainerId[lang] || 'Homepage V1';

    const skip = enabled && isTargetOfferLoading;

    const {
        loading,
        data = {},
    } = useContainers(
        [containerId],
        {
            ssr: !enabled,
            skip,
        }
    );

    const { isModalOpen } = useModalStore();

    const isFilterModalOpen = isModalOpen(FILTER_MODAL_NAME);

    return (
        <Component
            data={data}
            isLoading={skip || loading}
            isFilterModalOpen={isFilterModalOpen}
        />
    );

};

export default Homepage;
